import React from 'react';
import { Play } from 'lucide-react';
import { motion } from 'framer-motion';
export function Testimonial() {
  return <section className="bg-primary-dark py-24 text-white relative overflow-hidden" data-id="element-194">
      <div className="container mx-auto px-6" data-id="element-195">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-196">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative rounded-2xl overflow-hidden aspect-[4/3] max-w-lg" data-id="element-197">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80" alt="Testimonial" className="w-full h-full object-cover" data-id="element-198" />
            <div className="absolute inset-0 bg-black/20 flex items-center justify-center group cursor-pointer hover:bg-black/30 transition-colors" data-id="element-199">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300" data-id="element-200">
                <Play className="w-6 h-6 text-white ml-1 fill-white" data-id="element-201" />
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="max-w-lg" data-id="element-202">
            <div className="text-accent text-sm font-medium tracking-wider uppercase mb-8" data-id="element-203">
              What our clients say
            </div>
            <blockquote className="text-3xl md:text-4xl font-serif italic leading-tight mb-8" data-id="element-204">
              "AccuTemp's in-house team resolved our cooling issues in days, not
              the weeks we'd been quoted elsewhere. Their service reports are
              the most thorough we've seen."
            </blockquote>
            <div className="text-white/60 text-sm" data-id="element-205">
              <span className="text-white font-medium" data-id="element-206">James Mitchell</span>,
              Facilities Manager, Coventry Retail Park
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}